import NiceModal from '@ebay/nice-modal-react'
import dynamic from 'next/dynamic'
import { FC } from 'react'

const FeedbackModal = dynamic(() => import('@/components/modals/FeedbackModal'), { ssr: false })

export const SupportTab = () => {
  const onClickButton = () => {
    NiceModal.show(FeedbackModal as FC, { isAdvertisingModal: false })
  }

  return (
    <button
      onClick={onClickButton}
      className="support-tab"
      type="button"
    >
      <p>Feedback</p>
    </button>
  )
}
